import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../core/auth.service';

export const isLoginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const url = window.location.href;
  if (url.includes('?')) {
    const httpParams = url.split('?')[1];
    console.log('httpParams,:', httpParams);
    if (
      httpParams.includes('redirection') ||
      httpParams.includes('redirect_url') ||
      httpParams.includes('user_id')
    ) {
    } else if (httpParams.includes('token=')) {
      const urlParams = new URLSearchParams(httpParams);
      const token = urlParams.get('token');
      if (token) {
        authService.replaceToken(token);
        return true;
      }
    }
  }

  if (!authService.getAccessTokenId()) {
    router.navigateByUrl('/login');
    return false;
  } else {
    return true;
  }
};

/** @deprecated Use the functional `isLoginGuard` instead */
export { isLoginGuard as IsLoginGuard };
